"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.paymentStatusFactory = exports.PaymentStatusUseCase = void 0;
var domain_1 = require("@genoa/domain");
var PaymentStatusUseCase;
(function (PaymentStatusUseCase) {
    PaymentStatusUseCase["DOWN_PAYMENT_SCHEDULED"] = "FIRST_PAYMENT_SCHEDULED";
    PaymentStatusUseCase["PRE_PAY_DOWN_PAYMENT"] = "PAY_NOW_REPAYMENT";
    PaymentStatusUseCase["DOWN_PAYMENT_FAILED"] = "FIRST_PAYMENT_FAILED";
    PaymentStatusUseCase["DOWN_PAYMENT_COMPLETE"] = "FIRST_PAYMENT_COMPLETE";
    PaymentStatusUseCase["DOWN_PAYMENT_COMPLETE_PASSTHROUGH_FEE"] = "RENT_PAYMENT_COMPLETE_PASSTHROUGH_FEE";
    PaymentStatusUseCase["PAY_NOW_REPAYMENT"] = "PAY_NOW_REPAYMENT";
    PaymentStatusUseCase["ALL_PAYMENTS_COMPLETE"] = "ALL_PAYMENTS_COMPLETE";
})(PaymentStatusUseCase || (exports.PaymentStatusUseCase = PaymentStatusUseCase = {}));
var DISPLAY_STATUS_TO_STATUS_MAP = (_a = {},
    _a[domain_1.DisplayStatus.SCHEDULED] = domain_1.PaymentStatusV2.SCHEDULED,
    _a[domain_1.DisplayStatus.ACTION_NEEDED] = domain_1.PaymentStatusV2.SCHEDULED,
    _a[domain_1.DisplayStatus.FAILURE] = domain_1.PaymentStatusV2.SCHEDULED,
    _a[domain_1.DisplayStatus.FUNDED] = domain_1.PaymentStatusV2.SCHEDULED,
    _a[domain_1.DisplayStatus.PENDING] = domain_1.PaymentStatusV2.PENDING,
    _a[domain_1.DisplayStatus.REFUND] = domain_1.PaymentStatusV2.COMPLETE,
    _a[domain_1.DisplayStatus.UNPAID] = domain_1.PaymentStatusV2.COMPLETE,
    _a[domain_1.DisplayStatus.COMPLETE] = domain_1.PaymentStatusV2.COMPLETE,
    _a);
var getDueDate = function (category) {
    switch (category) {
        case domain_1.PaymentCategoryV2.MMF:
            return '2024-07-15';
        case domain_1.PaymentCategoryV2.REPAYMENT:
            return '2024-07-18';
        default:
            return '2024-07-01';
    }
};
var getNextChargeDate = function (status) {
    switch (status) {
        case domain_1.DisplayStatus.FAILURE:
            return '2024-07-20';
        default:
            return undefined;
    }
};
var paymentFactory = function (props) {
    var status = props.displayStatus ? DISPLAY_STATUS_TO_STATUS_MAP[props.displayStatus] : domain_1.PaymentStatusV2.SCHEDULED;
    var amount = 75000;
    var dueDate = getDueDate(props.category);
    return {
        // Using category as an id for now since it's unique for all implemented use cases, TODO: change for multiple payments in same category
        id: props.category,
        bp_month: '2024-07-01',
        bill_transaction_id: 'bt1',
        user_payment_public_id: props.category,
        category: props.category,
        status: status,
        due_date: dueDate,
        next_charge_date: getNextChargeDate(props.displayStatus),
        completion_date: status === domain_1.PaymentStatusV2.COMPLETE ? dueDate : undefined,
        total_amount_cents: amount,
        card_charge_amount: amount,
        display_status: props.displayStatus || domain_1.DisplayStatus.SCHEDULED,
        display_title: 'Payment',
        available_actions: props.availableActions || [],
        line_items: __spreadArray([
            {
                line_item_type: domain_1.LineItemType.BASE,
                amount_cents: amount,
                display_title: 'Base Payment',
            },
            {
                line_item_type: domain_1.LineItemType.PROCESSING_FEE,
                amount_cents: amount / 100,
                display_title: 'BP Fee (1%)',
            }
        ], (props.propertyPassthoroughFee
            ? [
                {
                    line_item_type: domain_1.LineItemType.PROPERTY_PASSTHROUGH_FEE,
                    amount_cents: (amount / 100) * 3,
                    display_title: 'Property Passthorugh Fee',
                },
            ]
            : []), true),
        transactions: status === domain_1.PaymentStatusV2.COMPLETE
            ? [
                {
                    display_title: 'Payment to Flex',
                    id: '1',
                    transaction_type: domain_1.TransactionTypeV2.PAYMENT,
                    transaction_status: domain_1.TransactionStatusV2.SUCCESS,
                    transaction_date: dueDate,
                    display_subtext: 'Dec 1',
                    completion_date: dueDate,
                    amount_cents: amount,
                    failure_reason: undefined,
                    payment_method_id: '123456',
                    payment_method_type: domain_1.PaymentMethodTypeV2.CARD,
                },
            ]
            : [],
    };
};
var paymentStatusFactory = function (_a) {
    var useCase = _a.useCase, history = _a.history;
    // TODO: Add Credit Builder use cases
    var payments;
    switch (useCase) {
        case PaymentStatusUseCase.DOWN_PAYMENT_SCHEDULED:
            payments = __spreadArray(__spreadArray([
                paymentFactory({ category: domain_1.PaymentCategoryV2.DOWN_PAYMENT, displayStatus: domain_1.DisplayStatus.SCHEDULED })
            ], (history
                ? [paymentFactory({ category: domain_1.PaymentCategoryV2.RENT_PAYMENT, displayStatus: domain_1.DisplayStatus.SCHEDULED })]
                : []), true), [
                paymentFactory({ category: domain_1.PaymentCategoryV2.MMF, displayStatus: domain_1.DisplayStatus.SCHEDULED }),
                paymentFactory({ category: domain_1.PaymentCategoryV2.REPAYMENT, displayStatus: domain_1.DisplayStatus.SCHEDULED }),
            ], false);
            break;
        case PaymentStatusUseCase.PRE_PAY_DOWN_PAYMENT:
            payments = __spreadArray(__spreadArray([
                paymentFactory({
                    category: domain_1.PaymentCategoryV2.DOWN_PAYMENT,
                    displayStatus: domain_1.DisplayStatus.SCHEDULED,
                    availableActions: [domain_1.PaymentAvailableAction.PRE_PAY],
                })
            ], (history
                ? [paymentFactory({ category: domain_1.PaymentCategoryV2.RENT_PAYMENT, displayStatus: domain_1.DisplayStatus.SCHEDULED })]
                : []), true), [
                paymentFactory({ category: domain_1.PaymentCategoryV2.MMF, displayStatus: domain_1.DisplayStatus.SCHEDULED }),
                paymentFactory({ category: domain_1.PaymentCategoryV2.REPAYMENT, displayStatus: domain_1.DisplayStatus.SCHEDULED }),
            ], false);
            break;
        case PaymentStatusUseCase.DOWN_PAYMENT_FAILED:
            payments = __spreadArray(__spreadArray([
                paymentFactory({ category: domain_1.PaymentCategoryV2.DOWN_PAYMENT, displayStatus: domain_1.DisplayStatus.FAILURE })
            ], (history
                ? [paymentFactory({ category: domain_1.PaymentCategoryV2.RENT_PAYMENT, displayStatus: domain_1.DisplayStatus.SCHEDULED })]
                : []), true), [
                paymentFactory({ category: domain_1.PaymentCategoryV2.MMF, displayStatus: domain_1.DisplayStatus.SCHEDULED }),
                paymentFactory({ category: domain_1.PaymentCategoryV2.REPAYMENT, displayStatus: domain_1.DisplayStatus.SCHEDULED }),
            ], false);
            break;
        case PaymentStatusUseCase.DOWN_PAYMENT_COMPLETE:
            payments = __spreadArray(__spreadArray([
                paymentFactory({ category: domain_1.PaymentCategoryV2.DOWN_PAYMENT, displayStatus: domain_1.DisplayStatus.SCHEDULED })
            ], (history
                ? [paymentFactory({ category: domain_1.PaymentCategoryV2.RENT_PAYMENT, displayStatus: domain_1.DisplayStatus.COMPLETE })]
                : []), true), [
                paymentFactory({ category: domain_1.PaymentCategoryV2.MMF, displayStatus: domain_1.DisplayStatus.SCHEDULED }),
                paymentFactory({
                    category: domain_1.PaymentCategoryV2.REPAYMENT,
                    displayStatus: domain_1.DisplayStatus.SCHEDULED,
                    availableActions: [domain_1.PaymentAvailableAction.PAY_NOW, domain_1.PaymentAvailableAction.RESCHEDULE],
                }),
            ], false);
            break;
        case PaymentStatusUseCase.DOWN_PAYMENT_COMPLETE_PASSTHROUGH_FEE:
            payments = __spreadArray(__spreadArray([
                paymentFactory({ category: domain_1.PaymentCategoryV2.DOWN_PAYMENT, displayStatus: domain_1.DisplayStatus.SCHEDULED })
            ], (history
                ? [paymentFactory({ category: domain_1.PaymentCategoryV2.RENT_PAYMENT, displayStatus: domain_1.DisplayStatus.COMPLETE })]
                : []), true), [
                paymentFactory({ category: domain_1.PaymentCategoryV2.MMF, displayStatus: domain_1.DisplayStatus.SCHEDULED }),
                paymentFactory({
                    category: domain_1.PaymentCategoryV2.REPAYMENT,
                    displayStatus: domain_1.DisplayStatus.SCHEDULED,
                    propertyPassthoroughFee: true,
                    availableActions: [domain_1.PaymentAvailableAction.PAY_NOW, domain_1.PaymentAvailableAction.RESCHEDULE],
                }),
            ], false);
            break;
        case PaymentStatusUseCase.PAY_NOW_REPAYMENT:
            payments = __spreadArray(__spreadArray([
                paymentFactory({ category: domain_1.PaymentCategoryV2.DOWN_PAYMENT, displayStatus: domain_1.DisplayStatus.SCHEDULED })
            ], (history
                ? [paymentFactory({ category: domain_1.PaymentCategoryV2.RENT_PAYMENT, displayStatus: domain_1.DisplayStatus.COMPLETE })]
                : []), true), [
                paymentFactory({ category: domain_1.PaymentCategoryV2.MMF, displayStatus: domain_1.DisplayStatus.SCHEDULED }),
                paymentFactory({
                    category: domain_1.PaymentCategoryV2.REPAYMENT,
                    displayStatus: domain_1.DisplayStatus.SCHEDULED,
                    availableActions: [domain_1.PaymentAvailableAction.PAY_NOW, domain_1.PaymentAvailableAction.RESCHEDULE],
                }),
            ], false);
            break;
        case PaymentStatusUseCase.ALL_PAYMENTS_COMPLETE:
            payments = __spreadArray(__spreadArray([
                paymentFactory({ category: domain_1.PaymentCategoryV2.DOWN_PAYMENT, displayStatus: domain_1.DisplayStatus.COMPLETE })
            ], (history
                ? [paymentFactory({ category: domain_1.PaymentCategoryV2.RENT_PAYMENT, displayStatus: domain_1.DisplayStatus.COMPLETE })]
                : []), true), [
                paymentFactory({ category: domain_1.PaymentCategoryV2.MMF, displayStatus: domain_1.DisplayStatus.COMPLETE }),
                paymentFactory({ category: domain_1.PaymentCategoryV2.REPAYMENT, displayStatus: domain_1.DisplayStatus.COMPLETE }),
            ], false);
            break;
        default:
            payments = [];
    }
    return history ? payments.filter(function (payment) { return payment.status === domain_1.PaymentStatusV2.COMPLETE; }) : payments;
};
exports.paymentStatusFactory = paymentStatusFactory;
